import { RecentlyAddedGallery } from "./RecentlyAddedGallery";
export default RecentlyAddedGallery;
